import request from '@/utils/request'

/**
 * @description: 优惠券-基础枚举接口
 * @param {String} params.key
 * @return {*}
 * @link https://yapi.jryghq.com/project/438/interface/api/30577
 */
export function getCouponCommonEnum(params) {
	return request({
		url: '/admin/v1/basic/conditions',
		method: 'get',
		params
	})
}
